import { Injectable } from '@angular/core';
import
{
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor
{
    constructor(
        private authenticationService: AuthService,
        private router: Router
    ) { }

    alertedOnce = false;

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>>
    {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) =>
            {
                if (err.status === 401)
                {
                    if (!this.alertedOnce)
                    {
                        alert('Не авторизован');
                        this.alertedOnce = true;
                    }

                    this.authenticationService.signOut();
                    this.router.navigate(['/sign-in']);
                    return throwError(() => new Error('Не авторизован'));
                }

                return this.parseErrorBlob(err);
            })
        );
    }

    parseErrorBlob(err: HttpErrorResponse): Observable<any>
    {
        const reader: FileReader = new FileReader();

        const obs = new Observable((observer: any) =>
        {
            reader.onloadend = (e) =>
            {
                observer.error(reader.result as string);
                observer.complete();
            }
        });
        reader.readAsText(err.error);
        return obs;
    }
}
